<template>
  <q-page class="column">
    <IacTable
      :rows="iacs"
      v-model:pagination="pagination"
      @del="excluirIac"
      @request="fetchIacTablePage"
    />
  </q-page>
</template>

<script setup>
import IacTable from "@/components/iac/IacTable.vue";
import {
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS
} from "@/DemandasRepetitivas";
import { useAppStore } from "@/store/app-store";
import { useIacStore } from "@/store/iac-store";
import { useQuasar } from "quasar";
import { computed, watch, ref } from "vue";
IacTable;

const quasar = useQuasar();
const iacStore = useIacStore();
iacStore.fetchPage(1, 10);
const appStore = useAppStore();
appStore.drawerExpanded = true

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  get rowsNumber() {
    return iacCount.value;
  },
  set rowsNumber(v) {
    iacCount.value = v;
  }
});

const iacCount = computed(() => iacStore.temasCount);
const currentPage = computed(() => pagination.value?.page);
watch(iacCount, () => (pagination.value.rowsNumber = iacCount.value));
watch(currentPage, () => (iacStore.page = currentPage.value));

const iacs = computed(() => iacStore.pages[pagination.value.page]);

const fetchIacTablePage = props => {
  Object.assign(pagination.value, props.pagination);
  props.pagination.rowsPerPage = props.pagination.rowsPerPage == 0 ? iacCount.value : props.pagination.rowsPerPage;
  fetchIacPage(props.pagination.page, props.pagination.rowsPerPage);
};

const search = () => fetchIacPage(1);
const fetchIacPage = (page = 1, rowsPerPage = 10) => iacStore.fetchPage(page, rowsPerPage);

const excluirIac = id => {
  const reload = search;
  const failure = () => notify(DELETE_FAILURE, "negative");
  const success = () => notify(DELETE_SUCCESS, "positive");

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`incidenteassuncaocompetencia/${id}`)
    .then(readResponse)
    .catch(failure);
};

const notify = (msg, color) => {
  const notifyObj = (message, color) => ({ message, color });
  quasar.notify(notifyObj(msg, color));
};
</script>
